module.exports = __webpack_public_path__ + "static/media/zr_2_17.1641f8b0.png";